export default "__VITE_ASSET__CjFn_wL0__"